module.exports = __webpack_public_path__ + "img/cornerqr.ca2f91f7.png";